import { formatDate } from '@angular/common';
export class TableFilter {

  static filter<T>(filterableArray: T[], input: string): T[] {

    return filterableArray.filter(entry => Object.keys(entry).some(function(key){

      const value = entry[key];

      if (typeof value === 'undefined' || value === null) {
        return false;
      }

      if (key.toLowerCase().includes('date')) {
        return formatDate(value, 'MM/dd/yyyy', 'en-US').includes(input) ||
               formatDate(value, 'MM/dd/yy', 'en-US').includes(input) ||
               formatDate(value, 'MM-dd-yyyy', 'en-US').includes(input) ||
               formatDate(value, 'MM-dd-yy', 'en-US').includes(input);
      }

      return value.toString().toUpperCase().includes(input.toUpperCase());
    }));
  }

  static filterAny(filterableArray: any[], input: string): any[] {

    if (!input) {
      return filterableArray;
    }

    return filterableArray.filter(entry => Object.keys(entry).some(function(key){

      const value = entry[key];

      if (typeof value === 'undefined' || value === null) {
        return false;
      }

      if (key.toLowerCase().includes('date')) {
        return formatDate(value, 'MM/dd/yyyy', 'en-US').includes(input) ||
               formatDate(value, 'MM/dd/yy', 'en-US').includes(input) ||
               formatDate(value, 'MM-dd-yyyy', 'en-US').includes(input) ||
               formatDate(value, 'MM-dd-yy', 'en-US').includes(input);
      }

      return value.toString().toUpperCase().includes(input.toUpperCase());
    }));
  }
}
